import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const plansReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.PLAN_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.PLAN_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.PLAN_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PLANS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PLANS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PLANS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PLAN_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PLAN_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PLAN_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const planReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.PLAN_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.PLAN_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.PLAN_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { plansReducer, planReducer };
